<!-- 
<h5 class="form-heading">
    <a class="angle-left" *ngIf="flag==2">
        <i class="fa fa-angle-left fa-lg" (click)="flag=1;"></i>
    </a>
    <a class="angle-left" *ngIf="flag==3">
        <i class="fa fa-angle-left fa-lg" (click)="flag=2;"></i>
    </a>
    Resume

    <a *ngIf="flag==1">
        <i class="fa fa-times float-right pt-2 mt-1" (click)="cancel()"></i>
    </a>
</h5>


<form [formGroup]="resume_referral">
    <div class="row" *ngIf="flag==1">
        <div class="col-md-12 col-sm-12 pt-1 pb-1">
            <div style="text-align: center">
                <label>
                    Upload your CV
                    <app-files-duplicate [flag]="1" (returnFiles)="saveFileResult($event)" class="form-control"
                        [result]="resume_details.files"></app-files-duplicate>
                </label>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field floatLabel="always">
                        <mat-label>First Name</mat-label>
                        <input name="Title" class="w-93" [required]="true" matInput placeholder="First Name"
                            formControlName="first_name">
                    </mat-form-field>
                </div>

            </div>
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field floatLabel="always">
                        <mat-label>Last Name</mat-label>
                        <input name="last" class="w-93" [required]="true" matInput placeholder="Last Name"
                            formControlName="last_name">
                    </mat-form-field>
                </div>

            </div>

            <div class="row">
                <div class="col-md-12">
                    <mat-form-field floatLabel="always">
                        <mat-label>Email ID</mat-label>
                        <input name="email" class="w-93" [required]="true" matInput placeholder="Email ID"
                            formControlName="email_id">
                    </mat-form-field>
                </div>

            </div>
            <div class="row">
                <div class="col-md-4">
                
                    <app-select-search [mandatory]="true" [options]="master['isd']" [form_group]="resume_referral"
                        form_control="mobile_no_cc" title_property="isd" id_property="isd_code" placeholder="ISD"
                        float_label="always" label="Country Code" float_label="always"
                        selected_input="resume_details.mobile_no_cc"></app-select-search>
                </div>
                <div class="col-md-8">
                    <mat-form-field floatLabel="always">
                        <mat-label>Phone Number</mat-label>
                        <input name="phone" class="w-93" [required]="true" matInput placeholder="Phone Number"
                            formControlName="mobile_no" type="number"
                            onKeyPress="if(this.value.length==10) return false;">
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field floatLabel="always">
                        <mat-label>Current Location</mat-label>
                        <mat-select name="location-code" placeholder="< - - Select - - >"
                            formControlName="current_location">
                            <input [(ngModel)]="search_loc" [ngModelOptions]="{standalone: true}" type="text" name=""
                                id="" placeholder="Search" class="form-control">
                            <cdk-virtual-scroll-viewport style="height:35vh;" [itemSize]="10" class="example-viewport">
                                <mat-option *cdkVirtualFor="let section of master['location']| filter:search_loc"
                                    [value]="section.location_code">
                                    {{section.location_title}}
                                </mat-option>
                            </cdk-virtual-scroll-viewport>
                        </mat-select>
                    </mat-form-field>
                </div>

            </div>
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field floatLabel="always">
                        <mat-label>Pin Code</mat-label>
                        <input name="PinCode" class="w-93" type="number" min="0" matInput placeholder="Pin code"
                            formControlName="experience">
                    </mat-form-field>
                </div>
            </div>

        </div>
        <div class="col-md-12">
            <button class="float-right  ml-1 btn btn-sm btn-primary" (click)="flag=2;">
                Next
            </button>
        </div>
    </div>
    <div class="row" *ngIf="flag==2">
        <div class="col-md-12 col-sm-12 pt-1 pb-1">
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field floatLabel="always">
                        <mat-label>Experience </mat-label>
                        <input name="experience" class="w-93" type="number" min="0" matInput placeholder="Experience"
                            formControlName="experience">
                    </mat-form-field>
                </div>
                <div class="col-md-12">
                    <mat-form-field floatLabel="always">
                        <mat-label>Designation</mat-label>
                        <mat-select name="Designation" placeholder="Current Designation"
                            formControlName="current_designation">
                            <mat-option [disabled]="true">
                                None
                            </mat-option>
                            <mat-option *ngFor="let section of master['designation']"
                                [value]="section.designation_code">
                                {{section.designation_title}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

            </div>
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field floatLabel="always">
                        <mat-label>Notice Period (Days)</mat-label>
                        <input name="notice-period" class="w-93" min="0" type="number" matInput
                            placeholder="Notice Period" formControlName="notice_period">
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field floatLabel="always">
                        <mat-label>Employer</mat-label>
                        <input name="employee" class="w-93" matInput placeholder="Current Employer"
                            formControlName="current_employee">
                    </mat-form-field>
                </div>

            </div>

            <div class="row">
                <div class="col-md-6">
                    <mat-form-field floatLabel="always">
                        <mat-label>Currency</mat-label>
                        <mat-select name="form-code" placeholder="< - - Select - - >" formControlName="currency_code">
                            <mat-option [disabled]="true">
                                None
                            </mat-option>
                            <mat-option *ngFor="let section of master['currency']" [value]="section.country_code">
                                {{section.currency_title}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6">
                    <mat-form-field floatLabel="always">
                        <mat-label>Amount</mat-label>
                        <input name="Amount" class="w-93" matInput placeholder="Amount" formControlName="amount">
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <mat-form-field floatLabel="always">
                        <mat-label>Duration</mat-label>
                        <mat-select name="form-code" placeholder="< - - Select - - >" formControlName="duration_code">
                            <mat-option [disabled]="true">
                                None
                            </mat-option>
                            <mat-option *ngFor="let section of master['duration']" [value]="section.duration_code">
                                {{section.duration_title}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6">
                    <mat-form-field floatLabel="always">
                        <mat-label>Scale</mat-label>
                        <mat-select name="form-code" placeholder="< - - Select - - >" formControlName="scale_code">
                            <mat-option [disabled]="true">
                                None
                            </mat-option>
                            <mat-option *ngFor="let section of master['scale']" [value]="section.scale_code">
                                {{section.scale_title}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

            </div>
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field floatLabel="always">
                        <mat-label>Education</mat-label>
                        <mat-select name="form-code" placeholder="< - - Select - - >" formControlName="education_code"
                            multiple>
                            <mat-option [disabled]="true">
                                None
                            </mat-option>
                            <mat-option *ngFor="let section of master['education']" [value]="section.education_id">
                                {{section.education_type}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

            </div>

            <div class="row">
                <div class="col-md-12">
                    <mat-form-field floatLabel="always">
                        <mat-label>Skills</mat-label>
                        <mat-select name="form-code" placeholder="< - - Select - - >" multiple
                            formControlName="skill_code">
                            <mat-option [disabled]="true">
                                None
                            </mat-option>
                            <mat-option *ngFor="let section of master['skills']" [value]="section.skill_code">
                                {{section.skill_title}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

            </div>
            <div class="row">
                <div class="col-md-12">
                    <button class="btn btn-sm btn-light" (click)="flag=1;">
                        Previous
                    </button>
                    <button class="float-right  ml-1 btn btn-sm btn-primary" (click)="skill()">
                        Next
                    </button>
                </div>
            </div>
        </div>

    </div>
</form>

<div class="row" *ngIf="flag==3">
    <div class="col-md-12 col-sm-12 pt-1 pb-1 ">



        <div class="row pr-2 pl-2 p-3" style="margin-bottom: 30px;"
            *ngFor="let skill of resume_details.skill_rating;let i=index">
            <div class="col-md-12">
                <strong>{{skill.skill_title}}</strong>
            </div>
            <div class="col-md-12">
                <ng5-slider [(value)]="skill.skill_rating" [options]="options"></ng5-slider>
            </div>

        </div>


        <div class="row p-2 pl-3 pr-3">
            <button class="btn btn-sm btn-light mt-2 float-left" (click)="skillRating()">
                Previous
            </button>
            <button class="float-right ml-auto mt-2 btn btn-sm btn-danger" (click)="cancel()">
                Cancel
            </button>
            <button [disabled]="loading" class="float-right  ml-1 mt-2 btn btn-sm btn-primary" (click)="save()">
                <div *ngIf="loading" style="text-align: center;">
                    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
                </div>
                <span *ngIf="!loading">
                    Save
                </span>
            </button>

        </div>
    </div>
</div> -->




<div style="padding: 5px;" class="pt-0">
    <h5 class="form-heading">
        <a class="angle-left" *ngIf="flag==2">
            <i class="fa fa-angle-left fa-lg" (click)="flag=1;"></i>
        </a>
        <a class="angle-left" *ngIf="flag==3">
            <i class="fa fa-angle-left fa-lg" (click)="flag=2;"></i>
        </a>
        Apply
        <a *ngIf="flag==2 && skill_match==true">
            <i class="fa fa-angle-right float-right fa-lg pt-2 mt-1" (click)="flag=3;"></i>
        </a>
        <a *ngIf="flag==1">
            <i class="fa fa-times float-right pt-2 mt-1" (click)="cancel()"></i>
        </a>
    </h5>


    <form [formGroup]="resume_referral">
        <div class="row" *ngIf="flag==1">
            <div class="col-md-12 col-sm-12 pt-1 pb-1">
                <label class="mb-1 document" style="    color: black;
                font-size: 13px;
                font-weight: 500;">Resume Document
                    <span style="color: red !important;">*</span>
                </label>
                <div class="form-group mb-4 mt-1" style="text-align: center;">
                    <app-files-duplicate [flag]="1" class="form-control" (returnFiles)="saveFileResult($event)" class="form-control" [result]="resume_details.files"
                        [file_length]="length_file">
                    </app-files-duplicate>
                </div>
                <!-- <div style="text-align: center">
                    <label>
                        Upload your CV
                        <app-files [flag]="1" (returnFiles)="saveFileResult($event)" class="form-control"
                            [result]="resume_details.files"></app-files>
                    </label>
                </div> -->
                <div class="row ">
                    <div class="col-md-6 form-group">
                        <mat-form-field floatLabel="always">
                            <mat-label>First Name</mat-label>
                            <input name="Title" [required]="true" id="first" (keydown)="inputText($event,100)" class="w-93" matInput placeholder="First Name"
                                formControlName="first_name">
                            <mat-error *ngIf="resume_referral.controls.first_name.errors">
                                <div *ngIf="resume_referral.controls.first_name.errors.required">First Name is required
                                </div>
                                <div *ngIf="resume_referral.controls.first_name.errors.minlength">First Name must be at least 1 character</div>
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 form-group">
                        <mat-form-field floatLabel="always">
                            <mat-label>Last Name</mat-label>
                            <input name="last" (keydown)="inputTextMaxNull($event)" class="w-93" matInput placeholder="Last Name" formControlName="last_name">
                        </mat-form-field>
                    </div>

                </div>

                <div class="row  ">
                    <div class="col-md-12 form-group">
                        <mat-form-field floatLabel="always">
                            <mat-label>Email ID</mat-label>
                            <input name="email" [required]="true" class="w-93" matInput placeholder="test@example.com" formControlName="email_id" (keydown)="inputEmail($event)">
                            <mat-error *ngIf="resume_referral.controls.email_id.errors">
                                <div *ngIf="resume_referral.controls.email_id.errors.required">Email ID is required
                                </div>
                                <div *ngIf="resume_referral.controls.email_id.errors.pattern">Enter valid Email</div>
                            </mat-error>
                        </mat-form-field>
                    </div>

                </div>
                <div class="row ">
                    <div class="col-md-6 form-group">
                        <app-select-search [mandatory]="true" [options]="master['isd']" [form_group]="resume_referral" form_control="mobile_no_cc"
                            title_property="isd" id_property="isd_code" placeholder="Country Code" float_label="always" label="Country Code"
                            float_label="always" [selected_input]="resume_referral.value.mobile_no_cc" (selected_obj)="selected_obj($event)">
                        </app-select-search>
                    </div>
                    <div class="col-md-6 form-group">
                        <mat-form-field floatLabel="always">
                            <mat-label>Mobile Number</mat-label>
                            <input name="phone" [required]="true" class="w-93" matInput placeholder="Mobile Number" formControlName="mobile_no" type="number"
                                (keydown)="inputNumber($event)">
                            <mat-error *ngIf="resume_referral.controls.mobile_no.errors">
                                <div *ngIf="resume_referral.controls.mobile_no.errors.required">Mobile Number is required
                                </div>
                                <div *ngIf="resume_referral.controls.mobile_no.errors.min">Please enter {{mobile_number_length}} digit Mobile Number</div>
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 form-group">

                        <app-select-search [options]="master['location']" [form_group]="resume_referral" form_control="current_location" title_property="location_title"
                            id_property="location_code" placeholder="< - - Select - - >" float_label="always" label="Current Location"
                            float_label="always" selected_input="resume_details.current_location"></app-select-search>

                    </div>
                    <div class="col-md-6 form-group">
                        <mat-form-field floatLabel="always">
                            <mat-label>Pin Code</mat-label>
                            <input name="PinCode" class="w-93" type="number" min="0" matInput placeholder="Pin Code" formControlName="pin_code">
                        </mat-form-field>
                    </div>

                </div>
                <div class="row ">
                    <div class="col-md-12 form-group">
                        <mat-form-field floatLabel="always">
                            <mat-label>Experience</mat-label>
                            <input name="experience" class="w-93" type="number" min="0" matInput placeholder="Experience" formControlName="experience">
                        </mat-form-field>
                    </div>
                    <!-- <div class="col-md-6 form-group">
                        <mat-form-field floatLabel="always">
                            <mat-label>Relevant Experience </mat-label>
                            <input name="relevant_experience" class="w-93" type="number" min="0" matInput
                                placeholder="Relevant Experience" formControlName="relevant_experience">
                        </mat-form-field>
                    </div> -->
                    <!-- <div class="col-md-6">
                        <mat-form-field floatLabel="always">
                            <mat-label>Designation</mat-label>
                            <mat-select name="Designation" placeholder="Current Designation"
                                formControlName="current_designation">
                                <mat-option [disabled]="true">
                                    None
                                </mat-option>
                                <mat-option *ngFor="let section of master['designation']"
                                    [value]="section.designation_code">
                                    {{section.designation_title}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div> -->

                </div>
                <div class="row ">
                    <div class="col-md-12 form-group">
                        <mat-form-field floatLabel="always">
                            <mat-label>Skills</mat-label>
                            <mat-select name="form-code" placeholder="< - - Select - - >" formControlName="skill_code" multiple>
                                <!-- <mat-option [disabled]="true">
                                    None
                                </mat-option> -->
                                <mat-option *ngFor="let section of master['skills']" [value]="section.skill_code">
                                    {{section.skill_title}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                </div>
                <div class="row next">
                    <div class="col-md-12">
                        <button class="float-right ml-1 btn btn-sm btn-primary" (click)="flagSecond()">
                            Next
                        </button>
                    </div>
                </div>
            </div>

        </div>
        <div class="row" *ngIf="flag==2">
            <div class="col-md-12 col-sm-12 pt-1 pb-1">
                <div class="row form-group" *ngIf="value">
                    <div class="col-md-12">
                        <div class="card p-3" style="border: 0.5px solid gainsboro;
                        margin-bottom: 10px;border-radius:5px !important">
                            <p>{{description}}</p>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <p (click)="termsConditions()">
                            <input id="field_terms" type="checkbox" [(ngModel)]="terms_conditions" [ngModelOptions]="{standalone: true}" name="terms"> I accept the
                            <u>Terms and Conditions
                            </u>
                        </p>
                    </div>
                </div>
                <div class="row apply">
                    <div class="col-md-12">
                        <button [disabled]="loading" class="float-right  ml-1 mt-2 btn btn-sm btn-primary" (click)="save()">
                            <div *ngIf="loading" style="text-align: center;">
                                <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
                            </div>
                            <span *ngIf="!loading">
                                Apply
                            </span>
                        </button>
                        <button class="float-right ml-auto mt-2 btn btn-sm btn-danger" (click)="cancel()">
                            Cancel
                        </button>
                        <button class="btn btn-sm btn-light mt-2" (click)="flag=1">
                            Previous
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="row " *ngIf="flag==2">
            <div class="col-md-12 col-sm-12 pt-1 pb-1">
                <div class="row form-group">
                    <div class="col-md-6">
                        <mat-form-field floatLabel="always">
                            <mat-label>Notice Period (Days)</mat-label>
                            <input name="notice-period" class="w-93" min="0" type="number" matInput
                                placeholder="Notice Period" formControlName="notice_period">
                        </mat-form-field>
                    </div>
                    <div class="col-md-6">
                        <mat-form-field floatLabel="always">
                            <mat-label>Employer</mat-label>
                            <input name="employee" class="w-93" matInput placeholder="Current Employer"
                                formControlName="current_employee">
                        </mat-form-field>
                    </div>
    
                </div>
    
                <div class="row form-group">
                    <div class="col-md-6">
                        <mat-form-field floatLabel="always">
                            <mat-label>Currency</mat-label>
                            <mat-select name="form-code" placeholder="< - - Select - - >" formControlName="currency_code">
                                <mat-option [disabled]="true">
                                    None
                                </mat-option>
                                <mat-option *ngFor="let section of master['currency']" [value]="section.country_code">
                                    {{section.currency_title}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6">
                        <mat-form-field floatLabel="always">
                            <mat-label>Amount</mat-label>
                            <input name="Amount" class="w-93" matInput placeholder="Amount" formControlName="amount">
                        </mat-form-field>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-md-6">
                        <mat-form-field floatLabel="always">
                            <mat-label>Scale</mat-label>
                            <mat-select name="form-code" placeholder="< - - Select - - >" formControlName="scale_code">
                                <mat-option [disabled]="true">
                                    None
                                </mat-option>
                                <mat-option *ngFor="let section of master['scale']" [value]="section.scale_code">
                                    {{section.scale_title}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
    
                    <div class="col-md-6">
                        <mat-form-field floatLabel="always">
                            <mat-label>Duration</mat-label>
                            <mat-select name="form-code" placeholder="< - - Select - - >" formControlName="duration_code">
                                <mat-option [disabled]="true">
                                    None
                                </mat-option>
                                <mat-option *ngFor="let section of master['duration']" [value]="section.duration_code">
                                    {{section.duration_title}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
    
                </div>
                <div class="row form-group">
                    <div class="col-md-12">
                        <mat-form-field floatLabel="always">
                            <mat-label>Education</mat-label>
                            <mat-select name="form-code" placeholder="< - - Select - - >" formControlName="education_code"
                                multiple>
                                <mat-option [disabled]="true">
                                    None
                                </mat-option>
                                <mat-option *ngFor="let section of master['education']" [value]="section.education_id">
                                    {{section.education_type}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
    
                </div>
    
                <div class="row form-group">
                    <div class="col-md-6">
                        <mat-form-field floatLabel="always">
                            <mat-label>Skills</mat-label>
                            <mat-select name="form-code" placeholder="< - - Select - - >" multiple
                                formControlName="skill_code">
                                <mat-option [disabled]="true">
                                    None
                                </mat-option>
                                <mat-option *ngFor="let section of master['skills']" [value]="section.skill_code">
                                    {{section.skill_title}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 ">
                        <mat-form-field floatLabel="always">
                            <mat-label>Relevant Experience </mat-label>
                            <input name="relevant_experience" class="w-93" type="number" min="0" matInput
                                placeholder="Relevant Experience" formControlName="relevant_experience">
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div class="col-md-12">
    
                <button class="btn btn-sm btn-light mt-2" (click)="flag=1;">
                    Previous
                </button>
                <button class="float-right  ml-1 btn btn-sm btn-primary" (click)="skill()">
                    Next
                </button>
            </div>
        </div>
     -->

        <!-- <div class="row" *ngIf="flag==3 ">
            <div class="col-md-12 col-sm-12 pt-1 pb-1">
                <ng-container *ngIf="skill_match==true">
    
                    <div class="row form-group" style="margin-bottom: 30px;
                    padding-left: 26px;
                    padding-right: 18px;
                    width: 366px;
                    overflow: auto;" *ngFor="let skill of resume_details.skill_rating;let i=index">
                        <div class="col-md-12">
                            <strong>{{skill.skill_title}}</strong>
                        </div>
                        <div class="col-md-12">
                            <ng5-slider [(value)]="skill.skill_rating" [options]="options"></ng5-slider>
                        </div>
    
                    </div>
                </ng-container>
                <button [disabled]="loading" class="float-right  ml-1 mt-2 btn btn-sm btn-primary" (click)="save()">
                    <div *ngIf="loading" style="text-align: center;">
                        <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
                    </div>
                    <span *ngIf="!loading">
                        Save
                    </span>
                </button>
                <button class="float-right ml-auto mt-2 btn btn-sm btn-danger" (click)="cancel()">
                    Cancel
                </button>
                <button class="btn btn-sm btn-light mt-2" (click)="skillRating()">
                    Previous
                </button>
    
            </div>
        </div> -->
    </form>
</div>